import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { GOODS_RECEIPT_ITEM_BREAKDOWN, } from '../types/goods-receipt-item-breakdown.js';
/**
 * Descriptor for GoodsReceiptItemBreakdown.
 * Path: org/{orgId}/goods-receipt/{goodsReceiptId}/item/{itemId}/breakdown
 */
export const goodsReceiptItemBreakdownDescriptor = {
    name: GOODS_RECEIPT_ITEM_BREAKDOWN,
    label: 'Breakdown do item do recebimento',
    domain: 'purchasing',
    collectionPath: 'org/{orgId}/goods-receipt/{goodsReceiptId}/item/{itemId}/breakdown',
    pathPatternKeys: {
        orgId: 'string',
        goodsReceiptId: 'string',
        itemId: 'string',
    },
    version: 1,
    description: 'Size distribution of a goods-receipt line — full ProductVariant per size',
    repositoryConfig: {
        dataSource: DataSourceStrategy.PostgresRest,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: [DataSourceStrategy.PostgresRest],
    fields: [
        { name: 'id', label: 'ID', type: 'string', required: true },
        { name: 'goodsReceiptItemId', label: 'Item do recebimento', type: 'string', required: true },
        { name: 'variantId', label: 'Variante', type: 'string', required: true },
        { name: 'quantity', label: 'Quantidade', type: 'number', display: 'quantity', required: true },
    ],
    foreignKeys: [
        {
            fieldName: 'variantId',
            targetEntity: 'ProductVariant',
            relationship: 'many-to-one',
            displayField: 'description',
        },
    ],
};
//# sourceMappingURL=goods-receipt-item-breakdown.descriptor.js.map